import type { VehicleGuarantee } from '@core/Entities/Vehicle/VehicleGuarantee.entity';
import { useModal } from '@modal/Hooks/UseModal';
import { GuaranteeTag } from '@shared-components/GuaranteeTag/GuaranteeTag';

import { GuaranteeModal } from '../GuaranteeModal/GuaranteeModal';

import styles from './GuaranteeWrapper.module.css';

export const GuaranteeWrapper = ({
  messages,
  guarantee,
}: {
  messages: Record<string, string>;
  guarantee: VehicleGuarantee;
}) => {
  const { openModal } = useModal();

  const { content, name, durationInMonths } = guarantee;

  const openGuaranteeModal = () => {
    const modalComponent = <GuaranteeModal messages={messages} content={content} />;

    openModal(modalComponent, {
      header: messages.modalHeader,
      modalClassName: styles.modalContainer,
      modalBodyClassName: styles.modalBody,
    });
  };

  return (
    <GuaranteeTag
      className={styles.guaranteeWrapper}
      handleClick={openGuaranteeModal}
      messages={messages}
      name={name}
      duration={durationInMonths}
    />
  );
};
